import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Header from "../../../components/Layout/Header/Header";
import Footer from "../../../components/Layout/Footer/Footer";

import { SREEMenu } from "../../../components/Layout/DepartmentMenu";

import ScrollToTop from "../../../components/Common/ScrollTop";
import OffWrap from "../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../components/Common/Breadcumb";
import SearchModal from "../../../components/Layout/Header/SearchModal";
// Image
import footerLogo from "../../../assets/img/logo/lite-logo.png";

import QuickLinks from "../../../components/Common/QuickLinks";
import { fetchData, imageBaseURL } from "../../../utils/fetchData";
import {
  getAPIPath,
  getMenu,
  getPageTitle,
} from "../../../utils/getDomainData";
import { BlocksRenderer } from "../../../components/BlockRenderer";
const currentDomain = process.env.REACT_APP_SUB_DOMAIN;
const CommonFaculty = () => {
  const [data, setData] = useState([]);
  const [facultyDescription, setFacultyDescription] = useState(null);
  useEffect(() => {
    fetchData(getAPIPath()?.faculties, setData);
    if (getAPIPath()?.facultyDescription) {
      fetchData(getAPIPath()?.facultyDescription, setFacultyDescription);
    }
  }, []);
  const dynamicStyles = {
    style1: {
      width: "150px",
    },
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>Faculty – {getPageTitle()}</title>
        <meta name="description" content="" />
        <meta name="keywords" content=""></meta>
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="home"
        TopBar="enable"
        TopBarclassName="topbar-area dark-primary-bg hidden-lg"
      />
      <div className="pageTopOffset">
        <SiteBreadcrumb
          pageTitle="Faculty"
          pageName="Faculty"
          breadcrumbsclassName="breadcrumb-bg"
        />
        {getMenu()}

        <div id="rs-about" className="rs-about style3 pt-50 pb-50 md-pt-30">
          <div className="container">
            <div className="row">
              <div className="col md-mb-30">
                <div className="content-wrapper">
                  <div className="content-section">
                    <h3 title="Faculty">Faculty</h3>
                    {data?.data?.map((faculty) => (
                      <div className="row mb-40 flex-column flex-sm-row">
                        <div
                          className={`image-column md-mb-50 ${
                            !showQuickLinks(currentDomain)
                              ? "col-lg-2"
                              : "col-lg-3"
                          }`}
                          style={
                            !showQuickLinks(currentDomain)
                              ? dynamicStyles.style1
                              : dynamicStyles.style1
                          }
                        >
                          <div className="inner-column">
                            <div className="image">
                              <img
                                src={
                                  imageBaseURL +
                                  (faculty?.attributes?.Image?.data?.attributes
                                    ?.formats?.thumbnail?.url ||
                                    faculty?.attributes?.Image?.data?.attributes
                                      ?.url)
                                }
                                alt={faculty?.attributes?.Name || ""}
                                title={faculty?.attributes?.Name || ""}
                                className="w-100"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="content-column col">
                          <div className="inner-column">
                            <h2 title={faculty?.attributes?.Name || ""}>
                              {faculty?.attributes?.Name || ""}
                            </h2>
                            <p>
                              <strong>
                                {faculty?.attributes?.Education || ""}
                                {currentDomain === "ssit" &&
                                  faculty?.attributes?.Profile_Pdf?.data
                                    ?.attributes?.url && (
                                    <a
                                      href={`${imageBaseURL}${faculty?.attributes?.Profile_Pdf?.data?.attributes?.url}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{ marginLeft: "30px" }}
                                    >
                                      Profile View
                                    </a>
                                  )}

                                <span>{}</span>
                              </strong>
                            </p>
                            <p>
                              <strong>
                                {faculty?.attributes?.Designation}
                              </strong>
                              {faculty?.attributes?.Designation ===
                                "Programme Director" &&
                                ", School of Renewable Energy and Environment"}
                            </p>
                            {faculty?.attributes?.Research_Interest && (
                              <>
                                <h4
                                  className="mt-10 mb-0"
                                  title="Research Interest"
                                >
                                  Research Interest
                                </h4>
                                <p>{faculty?.attributes?.Research_Interest}</p>
                              </>
                            )}
                            {faculty?.attributes?.Contact_Details && (
                              <>
                                <h4
                                  className="mt-10 mb-0"
                                  title="Contact details"
                                >
                                  Contact details
                                </h4>
                                <div className="d-flex">
                                  {faculty?.attributes?.Contact_Details}
                                </div>
                              </>
                            )}

                            <div className="d-flex">
                              {faculty?.attributes?.About}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                    {facultyDescription !== null && (
                      <BlocksRenderer
                        content={facultyDescription.data?.attributes?.Body}
                      />
                    )}
                  </div>
                </div>
              </div>
              {showQuickLinks(currentDomain) && (
                <div className="col-lg-3 pl-20 md-pl-14">
                  <div className="about-intro">
                    <QuickLinks />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* <Accredation /> */}

      <Footer
        footerclassName="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />

      {/* scrolltop-start */}
      <ScrollToTop scrollClassName="scrollup secondaryColor" />
      {/* scrolltop-end */}

      <SearchModal />
    </React.Fragment>
  );
};

export default CommonFaculty;
const showQuickLinks = (currentDomain) => {
  if (currentDomain === "shsr") return true;
  else if (currentDomain === "ssit") return true;
  else return false;
};
